import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import withInit from 'WithInit';
import { ShareIcon } from 'DesignSystem/Icons';
import { openEmailModal } from 'StaticBuilder/SessionEmail/SessionEmailActions';

const StaticEmailButton = ({ openEmailModal: openModal }) => (
  <button className="btn static-email-button" onClick={openModal}>
    <ShareIcon />
  </button>
);


StaticEmailButton.propTypes = {
  openEmailModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    openEmailModal,
  }, dispatch)
);

export const StaticEmailButtonWithRedux = ReactRedux.connect(
  null,
  mapDispatchToProps,
)(StaticEmailButton);

export default withInit(StaticEmailButtonWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/SessionEmail/StaticEmailButton.jsx